<template>
	<div class="story-overview-container">
		<div class="row title-input-container">
			<div class="col-sm-8 page-row center-content">
				<p class="inline-label">Experience:</p>
				<input class="title-input" type="text" v-model="experienceTitle" @input="updateExperienceTitle">
			</div>
			<div class="col-sm-4 page-row center-content">
				<p class="inline-label">Space:</p>
				<p class="inline-label">{{scene.chosenSpace.title}}</p>
			</div>
		</div>

		<div class="row tool-wrapper">
			<div class="col">
				<button class="my-btn" @click="saveExperience">Save</button>
				<button class="my-btn" @click="showAddNodeModal = true">Add step</button>
			</div>
			<div class="col menu-container">
				<button class="my-btn" @click="showManageExperienceMenu = !showManageExperienceMenu">Manage Experience</button>
				<button class="my-btn" @click="showBackHomeModal = true">Exit</button>
				<div v-if="showManageExperienceMenu" class="manage-experience-menu" v-click-outside="closeMenu">
					<button class="menu-btn">Export Appliance Bundle</button>
					<button class="menu-btn">Export Gallery Bundle</button>
					<button class="menu-btn" @click="openDeleteExperienceModal">Delete Experience</button>
				</div>
			</div>
		</div>

		<modal v-if="showAddNodeModal" :withOkBtn="true" :withCancelBtn="true" @close="showAddNodeModal = false" @ok="addNode">
			<div slot="header">Add new step</div>
			<div slot="body">
				<div class="form-group">
					<input class="form-input" type="text" v-model="newNodeTitle" placeholder="Edit Title">
				</div>
				<div class="form-group">
					<textarea class="form-input" type="text" v-model="newNodeDescription" placeholder="Add a small description" rows="2"></textarea>
				</div>
			</div>
		</modal>

		<modal v-if="showSaveExperienceModal" :withOkBtn="true" :withCancelBtn="false" @ok="showSaveExperienceModal = false">
			<div slot="header">Save experience</div>
			<div slot="body">
				Your experience is saved.
			</div>
		</modal>

		<modal v-if="showBackHomeModal" :withOkBtn="true" :withCancelBtn="true" @ok="backToHome" @close="showBackHomeModal = false">
			<div slot="header">Back to homepage</div>
			<div slot="body">
				Save experience and go back to home page?
			</div>
		</modal>

		<modal v-if="showDeleteExperienceModal" :withOkBtn="true" :withCancelBtn="true" @ok="deleteExperience" @close="showDeleteExperienceModal = false">
			<div slot="header">Delete Experience</div>
			<div slot="body">
				Are you sure you want to delete this experience?
			</div>
		</modal>
		
		<experience-flowchart @editDetails="editDetails" @editStep="editStep" :height="800"/>
	</div>
</template>

<script>
	import ExperienceFlowchart from '@/components/ExperienceFlowchart.vue'
	import Modal from '@/components/modals/Modal'
	import {mapGetters} from 'vuex'

	export default {
		name: 'StoryOverview',
		components: {
			ExperienceFlowchart,
			'modal': Modal
		},
		computed: {
			...mapGetters(['scene', 'myExperiences'])
		},
		data() {
			return {
				showAddNodeModal: false,
				showSaveExperienceModal: false,
				showBackHomeModal: false,
				showDeleteExperienceModal: false,
				showManageExperienceMenu: false,
				newNodeTitle: '',
				newNodeDescription: '',
				experienceTitle: ''
			}
		},
		mounted() {
			this.experienceTitle = this.scene.title;
		},
		methods: {
			canvasClick(e) {
				console.log('canvas Click, event:', e)
			},
			addNode() {
				this.showAddNodeModal = false;
				let maxID = Math.max(0, ...this.scene.nodes.map((link) => {
					return link.id
				}));
				let newNode = {
					id: maxID + 1,
					x: -400,
					y: 50,
					title: this.newNodeTitle ? this.newNodeTitle: `test${maxID + 1}`,
					description: this.newNodeDescription,
					channels: this.scene.chosenSpace.nodes
				};
				this.$store.dispatch({
					'type': 'addSceneNode',
					'newNode': newNode
				}).then(response => {
					this.newNodeTitle = '';
					this.newNodeDescription = '';
				});
			},
			editStep(node) {
				console.log('go to editStep page');
				this.$store.dispatch({
					'type': 'editStep',
					'editingStep': node
				}).then(response => {
					this.$router.push({path: 'edit_step'});
				});
			},
			editDetails(node) {
				let editedNode = this.scene.nodes.filter(function(el){
					return el.id == node.id;
				}.bind(this))[0];
				editedNode.title = node.title;
				editedNode.description = node.description;
			},
			saveExperience() {
				this.$store.dispatch({
					'type': 'saveScene',
					'sceneObj': this.scene
				}).then(response => {
					this.showSaveExperienceModal = true;
				});
			},
			updateExperienceTitle() {
				this.$store.dispatch({
					'type': 'updateExperienceTitle',
					'title': this.experienceTitle
				});
			},
			backToHome() {
				this.showBackHomeModal = false;
				this.$store.dispatch({
					'type': 'saveScene',
					'sceneObj': this.scene
				}).then(response => {
					this.$router.push({path: '/'});
				});
			},
			closeMenu() {
				this.showManageExperienceMenu = false;
			},
			openDeleteExperienceModal() {
				this.showManageExperienceMenu = false;
				this.showDeleteExperienceModal = true;
			},
			deleteExperience() {
				this.showDeleteExperienceModal = false;
				this.$store.dispatch({
					'type': 'deleteScene',
					'sceneObj': this.scene
				}).then(response => {
					this.$router.push({path: '/'});
				});
			}
		}
	}
</script>

<style scoped>
	.story-overview-container {
		text-align: center;
		margin: 0;
		overflow: hidden;
		height: 800px;
		padding-top: 80px;
	}

	.inline-label {
		padding-right: 10px;
		margin: auto 0;
	}

	.menu-container {
		position: relative;
	}

	.manage-experience-menu {
		position: absolute;
		top: 50px;
		left: 200px;
		display: flex;
		flex-direction: column;
		z-index: 10;
		border: 1px solid #a3a5a8;
		border-radius: 4px;
	}

	.menu-btn {
		text-align: left;
		background-color: #a3a5a8;
		border: none;
		color: white;
		font-size: 15px;
		font-family: inherit;
		padding: 10px 20px;
		transition: background-color 0.3s;
	}

	.menu-btn:hover {
		background-color: #3fa68b;
		transition: background-color 0.3s;
		cursor: pointer;
	}
</style>